export const environment = {
  production: false,
  showStagingWatermark: true,
  apiDomain: 'argo.ml3ds-uat-stage.com',
  productDataPath: 'https://argo.ml3ds-uat-stage.com/productdata',
  buildNumber: '_build_number_placeholder_',
  useServiceWorker: true,
  useUseBerry: true
};
